import { IState } from '../../../redux/reducer/index';
import { O2OCommonContainer } from '../../../common/container/O2OContainer';
import { bindActionCreators } from 'redux';
import { updateAccount, changePwd, updateEDMSendInBlue, getEDMSendInBlue } from '../ConsoleUsersAction';
import { updateOrgByAdminClient } from '../../orgs/OrgsAction';
import { UserCompanyComponentV2 } from './UserCompanyComponentV2';
import { getMe } from '../../../common/actions/CommonAction';
import { getCurrentUserOrgs } from '../../company/SelectCompanyAction';

function mapStateToProps(rootState: IState) {
  return {
    edmSendInBlue: rootState.edmSendInBlue,
    currentUserOrgs: rootState.currentUserOrgs,
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    updateAccount: bindActionCreators(updateAccount, dispatch),
    updateOrgByAdminClient: bindActionCreators(updateOrgByAdminClient, dispatch),
    changePwd: bindActionCreators(changePwd, dispatch),
    updateEDMSendInBlue: bindActionCreators(updateEDMSendInBlue, dispatch),
    getEDMSendInBlue: bindActionCreators(getEDMSendInBlue, dispatch),
    getCurrentUserOrgs: bindActionCreators(getCurrentUserOrgs, dispatch),
    getMe: bindActionCreators(getMe, dispatch),
  };
}

export const UserCompanyContainer = O2OCommonContainer(UserCompanyComponentV2, mapStateToProps, mapDispatchToProps);
